import Vuetify from '@/plugins/vuetify';

Vuetify.framework.lang.current = (localStorage.getItem('idioma')) ? localStorage.getItem('idioma') : 'pt';

export default {
  preFaturamento: {
    informacoesProcesso: [],
    financeiroPagar: [],
    comparativoProdutoInvoice: [],
    comparativoProdutoDI: [],
    custosEmissaoNF: [],
    produtosProcesso: [],
  },
  colunasInformacaoProcesso: [
    'referencia',
    'cliente',
    'CNPJ',
    'carregamentoProgramado',
    'presencaCarga',
    'liberacaoMapa',
    'liberacaoSiscarga',
    'agenciamentoInternacional',
    'transportador',
    'sugerirTrasnportadora',
    'responsavelFrete',
    'unidadeNegocio',
    'taxaCambialDI',
    'beneficioFiscal',
    'descricaoItem',
    'exportador',
    'fabricante',
    'despachante',
    'armazemDesembaraco',
    'recintoEntrada',
    'tipoCarga',
    'codigoInvoice',
    'quantidadeContainers',
    'quantidadeLIs',
    'LIs',
    'freeTime',
    'diasLivres',
    'CE',
    'DI',
    'Data',
    'desembaraco',
    'incoterm',
    'saldoConta',
    'custosAlocadosOutroProcesso',
    'THC',
    'observacoesProcesso',
  ],
  colunasTabelaFinanceiroPagar: [
    {
      value: 'codigo',
      i18n: 'codigo',
      text: '',
    },
    {
      value: 'processo',
      i18n: 'processo',
      text: '',
    },
    {
      value: 'referencia',
      i18n: 'referencia',
      text: '',
    },
    {
      value: 'emissao',
      i18n: 'emissao',
      text: '',
    },
    {
      value: 'numeroDocumento',
      i18n: 'numeroDocumento',
      text: '',
    },
    {
      value: 'adiantamento',
      i18n: 'adiantamento',
      text: '',
    },
    {
      value: 'tipoDocumento',
      i18n: 'tipoDocumento',
      text: '',
    },
    {
      value: 'descricaoPessoa',
      i18n: 'descricaoPessoa',
      text: '',
    },
    {
      value: 'UF',
      i18n: 'uf',
      text: '',
    },
    {
      value: 'valorBruto',
      i18n: 'valorBruto',
      text: '',
    },
    {
      value: 'valorLiquido',
      i18n: 'valorLiquido',
      text: '',
    },
    {
      value: 'situacao',
      i18n: 'situacao',
      text: '',
    },
    {
      value: 'previsao',
      i18n: 'previsao',
      text: '',
    },
  ],
  colunasTabelaComparativoProdutosDI: [
    {
      value: 'numAdicao',
      i18n: 'numAdicao',
      text: '',
    },
    {
      value: 'produto',
      i18n: 'produto',
      text: '',
    },
    {
      value: 'numItem',
      i18n: 'numItem',
      text: '',
    },
    {
      value: 'pesoLiquido',
      i18n: 'pesoLiquido',
      text: '',
    },
    {
      value: 'pesoBruto',
      i18n: 'pesoBruto',
      text: '',
    },
  ],
  colunasTabelaComparativoProdutosInvoice: [
    {
      value: 'item',
      i18n: 'item',
      text: '',
    },
    {
      value: 'codigoExportacao',
      i18n: 'codigoExportacao',
      text: '',
    },
    {
      value: 'codigoProduto',
      i18n: 'codigoProduto',
      text: '',
    },
    {
      value: 'pesoLiquido',
      i18n: 'pesoLiquido',
      text: '',
    },
    {
      value: 'pesoBruto',
      i18n: 'pesoBruto',
      text: '',
    },
  ],
  colunasTabelaCustosEmissaoNF: [
    {
      value: 'contaProjeto',
      i18n: 'contaProjeto',
      text: '',
    },
    {
      value: 'valorMoedaNacional',
      i18n: 'valorMoedaNacional',
      text: '',
    },
    {
      value: 'formaRateio',
      i18n: 'formaRateio',
      text: '',
    },
    {
      value: 'encargo',
      i18n: 'encargo',
      text: '',
    },
  ],
  colunasTabelaProdutosProcesso: [
    {
      value: 'codigoProduto',
      i18n: 'codigoProduto',
      text: '',
    },
    {
      value: 'unidadeNegocio',
      i18n: 'unidadeNegocio',
      text: '',
    },
    {
      value: 'descricaoCliente',
      i18n: 'descricaoCliente',
      text: '',
    },
    {
      value: 'ONU',
      i18n: 'ONU',
      text: '',
    },
    {
      value: 'classe',
      i18n: 'classe',
      text: '',
    },
    {
      value: 'embalagem',
      i18n: 'embalagem',
      text: '',
    },
    {
      value: 'ICMS',
      i18n: 'icms',
      text: '',
    },
  ],
  colunasTabelaDocumentosGED: [
    {
      value: 'nomePasta',
      i18n: 'nomePasta',
      text: '',
    },
    {
      value: 'documento',
      i18n: 'documento',
      text: '',
    },
  ],
  exibirConferenciaPreFaturamento: false,
};
